module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/home/components/home-main-modal-detail-member/home-main-modal-detail-member.component.sass
// module id = ./src/app/modules/home/components/home-main-modal-detail-member/home-main-modal-detail-member.component.sass
// module chunks = main